import React from "react";
import "./Error.css";
import FadeIn from "react-fade-in";

class ApiError extends React.Component {
 

  render() {
    return (
      <FadeIn>
        <div className="Errorbox">
        <div className="ErrorboxContent">
        <h3>GAMERLAN.no er ikke tilgjengelig</h3>
        <br/>
        <h5>Dette skyldes mest sannsynlig:</h5>
        <ul>
          <li>At vi utfører vedlikehold</li>
          <li>At vi utfører oppdateringer</li>
          </ul>
          <br/>
          <h5>Hvis problemet vedvarer:</h5>
          <ul>
          <li>Problem med ditt nettverk</li>
          <li>At du kjører en utdatert browser</li>
        </ul>

        </div>
        </div>
      </FadeIn>
    );
  }
}
export default ApiError;



// WEBPACK FOOTER //
// ./src/Components/Error/ApiError.js